import React, { ReactElement } from 'react';
import storeConnector from '@store/storeConnector';
import { SiteMeta } from '@src/types/SiteMeta';
import SuperstitionDiagram from '@src/sld/superstition/SuperstitionDiagram';
import BearCanyonDiagram from '@src/sld/bear_canyon/BearCanyonDiagram';
import WestFordFlatDiagram from '@src/sld/west_ford_flat/WestFordFlatDiagram';
import HatchRoadSolarDiagram from './hatchroadsolar/Diagram/Diagram';
import BrazosBendDiagram from './brazos_bend/BrazosBendDiagram';

const getSLD = (sitename: string) => {
  let diagram: ReactElement = <div />;

  switch (sitename.toLowerCase()) {
    case 'superstition':
      diagram = <SuperstitionDiagram />;
      break;
    case 'hatchroadsolar':
      diagram = <HatchRoadSolarDiagram />;
      break;
    case 'bear canyon':
      diagram = <BearCanyonDiagram />;
      break;
    case 'west ford flat':
      diagram = <WestFordFlatDiagram />;
      break;
    case 'brazos bend':
      diagram = <BrazosBendDiagram />;
      break;
    default:
      break;
  }

  return diagram;
};

function Diagram({ siteMeta }: { siteMeta: SiteMeta }): ReactElement {
  return getSLD(siteMeta.SiteName);
}

export default storeConnector(Diagram, {
  config: ['siteMeta'],
});
